import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import AgreementInfo from '~/src/features/full-buy/AgreementInfo';
import CallbackContacts from '~/src/features/full-buy/CallbackContacts';
import Feedback from '~/src/features/full-buy/Feedback';
import { calculateTotalPrices } from '~/src/features/full-buy/functions';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import TariffInclude from '~/src/features/full-buy/TariffInclude';
import { TicketFinal } from '~/src/features/full-buy/TicketFinal';
import { TState } from '~/src/store';

import * as S from '~/src/features/full-buy/containers/pages/styled';

export const TiketContainerFinal = (): JSX.Element => {
    const {
        slot,
        selectedTariff,
        products,
        agreementData,
    } = useSelector((state: TState) => ({
        slot: state.fullBuy.slot,
        selectedTariff: selectCurrentTariff(state),
        products: state.fullBuy.products,
        agreementData: state.fullBuy.agreement,
    }), shallowEqual);

    const isLaptop = useMatchMediaByWidth(wideBreakpoints.laptop);

    const { additionalProducts, price, promoPrice, connectionPrice } = selectedTariff || {};

    const { monthlyPayment, oncePayment } = useMemo(() => {
        return calculateTotalPrices(promoPrice || price, connectionPrice?.final, products);
    }, [price, promoPrice, connectionPrice?.final, additionalProducts, products]);

    const dateTime = slot?.date;

    return (
        <>
            <AgreementInfo
                agreementNumber={agreementData?.agreementNumber || null}
            />

            <S.Section>
                <TicketFinal
                    totalCost={monthlyPayment + oncePayment}
                    hasError={agreementData.hasError}
                    agreementNumber={agreementData?.agreementNumber}
                />
            </S.Section>

            {slot && agreementData?.agreementNumber && <Feedback/>}

            {isLaptop &&
                <>
                    <TariffInclude showLink={!!dateTime}/>
                    <H3>Если остались вопросы</H3>
                    <CallbackContacts/>
                </>
            }
        </>
    );
};
